/**
 * The `ch-grid-columnset` component represents a group of columns.
 * @deprecated Use `ch-tabular-grid` component instead. Use `ch-tabular-grid-columnset` instead.
 */
export class ChGridColumnset {
    el;
    columnSortChangedHandler(eventInfo) {
        const columns = Array.from(this.el.querySelectorAll("ch-grid-column"));
        columns.forEach(column => {
            if (column.columnId !== eventInfo.detail.columnId) {
                column.sortDirection = null;
            }
        });
    }
    static get is() { return "ch-grid-columnset"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-columnset.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-columnset.css"]
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "columnSortChanged",
                "method": "columnSortChangedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
